import { Component } from 'react'
import { connect } from 'react-redux'
import FaqList from 'components/FaqList'
import { CATEGORY_ICONS } from 'constants'
import { TrackingHOC, ProductNameHOC } from 'hocs'
import { fetchFaqs, fetchFaqCategories } from './actions'
import { selectCategoriesFetching, selectCategories } from './selectors'
import { selectCurrentPhoneId } from '../App/selectors'
import { updateTitle } from '../Breadcrumbs/actions'
import { selectAllDevices } from '../DeviceSlider/selectors'
import { addRecent } from '../RecentTopics/actions'
import { getCustomer } from 'helpers'

class FaqListContainer extends Component {
  initialState = {
    currentCategory: null,
    currentSubcat: null,
    currentFaq: null,
    scrollToCategory: null
  }

  state = this.initialState

  componentDidMount() {
    this.props.updateTitle('FAQs')
    if (this.props.deviceId) {
      this.props.fetchFaqCategories(this.props.deviceId)
    }

    const { category } = this.props.location.query
    if (category) {
      this.setState({ scrollToCategory: category })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.deviceId !== nextProps.deviceId && nextProps.deviceId) {
      this.props.fetchFaqCategories(nextProps.deviceId)
    }

    if (nextProps.deviceId !== this.props.deviceId && !nextProps.deviceId) {
      // Reset state when device is cleared to close all categories
      this.setState({ ...this.initialState })
    }
  }

  componentDidUpdate() {
    const { currentCategory, scrollToCategory } = this.state
    const { isFetching, categories } = this.props

    if (
      scrollToCategory &&
      !isFetching &&
      !currentCategory &&
      categories.length
    ) {
      this.setState({
        currentCategory: this.getCategoryId(scrollToCategory),
        scrollToCategory: null
      })
    }
  }

  handleClick = (type, id, title, deviceId) => {
    this.setState({ [type]: id === this.state[type] ? null : id })

    if (type === 'currentFaq') {
      this.trackClick(id, title)

      this.props.addRecent({
        contentType: 'faq',
        contentId: id,
        deviceId,
        contentTitle: title,
        customer: getCustomer()
      })
    }
  }

  icon = (category) => CATEGORY_ICONS[category] || 'folder-outline'

  trackClick = (id, title) => {
    this.props.createEvent({
      category: 'faqs',
      data: {
        action: 'ToggleSingleFAQ',
        target: id,
        faq_name: title
      }
    })
  }

  getCategoryId = (name) => {
    const category = this.props.categories.find(
      (category) => category.name === name
    )
    return category && category.PK
  }

  jumpToManuals = () => {
    const userGuides = this.props.categories.find(
      (category) => category.name === 'User Guides'
    )
    this.setState({ currentCategory: userGuides.PK })
  }

  generateProps = () => ({
    ...this.props,
    ...this.state,
    handleClick: this.handleClick,
    categoryIcon: this.categoryIcon,
    jumpToManuals: this.jumpToManuals,
    icon: this.icon
  })

  render() {
    return <FaqList {...this.generateProps()} />
  }
}

const mapStateToProps = (state) => ({
  categories: selectCategories(state),
  isFetching: selectCategoriesFetching(state),
  deviceId: selectCurrentPhoneId(state),
  devices: selectAllDevices(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchFaqs: (deviceId) => dispatch(fetchFaqs.request(deviceId)),
  fetchFaqCategories: (deviceId) =>
    dispatch(fetchFaqCategories.request(deviceId)),
  updateTitle: (title) => dispatch(updateTitle(title)),
  addRecent: (topic) => dispatch(addRecent(topic))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductNameHOC(TrackingHOC(FaqListContainer)))
